export default __webpack_public_path__ + "color_demo_app.png";